// extracted by mini-css-extract-plugin
export var chevron = "_ix-2";
export var chevronRotated = "_ix-3";
export var header = "_ix-1";
export var section = "_ix-0";